<template>
  <div style='height: 1300px;'>
    <FillStep />
    <div class='fill-warp'>
      <van-form ref='form'>
        <van-field
          v-model="baseInfo.apply_job_name"
          required
          clearable
          name="应聘职位"
          label="应聘职位"
          placeholder="请输入应聘职位"
          :rules="[{ required: true}]"
        />
        <van-field
          readonly
          clickable
          required
          name="picker"
          :value="baseInfo.can_work_time"
          label="到岗时间"
          placeholder="请选择到岗时间"
          @click="workTimePicker = true"
          :rules="[{ required: true }]"
        />
        <van-popup v-model="workTimePicker" position="bottom">
          <van-picker
          required
            show-toolbar
            :columns="workTimeSelect"
            @confirm="workTimeConfirm"
            @cancel="workTimePicker = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          required
          name="picker"
          :value="baseInfo.expected_salary"
          label="期望薪资"
          placeholder="请选择期望薪资"
          @click="salaryTypePicker = true"
        />
        <van-popup v-model="salaryTypePicker" position="bottom">
          <van-picker show-toolbar
            @change="onChange"
            @confirm="salaryTypeConfirm"
            @cancel="salaryTypePicker = false"
            :columns="salary" />
        </van-popup>
        
        


        <div style="margin: 16px;"></div>
        <van-field
          v-model="baseInfo.name"
          required
          clearable
          name="姓名"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true}]"
        />
        <van-field
          v-model="baseInfo.phone"
          required
          clearable
          type='tel'
          name="手机号"
          label="手机号"
          maxlength="11"
          placeholder="请填写手机号码"
        />
        <!-- :rules="[
              { required: true},
              { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误'}
            ]" -->
        <van-field
          v-model="baseInfo.e_mail"
          required
          clearable
          name="邮箱"
          label="邮箱"
          placeholder="请输入邮箱"
          :error-message="emailErrorText"          
        />
        <!-- :rules="[
              { required: true },
              { pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: '邮箱格式错误'}
            ]" -->
        <van-field
          readonly
          clickable
          required
          name="picker"
          :value="baseInfo.card_type"
          label="选择证件类型"
          placeholder="点击选择证件类型"
          @click="cardTypePicker = true"
        />
        <van-popup v-model="cardTypePicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="cardType"
            @confirm="cardTypeConfirm"
            @cancel="cardTypePicker = false"
          />
        </van-popup>
        <van-field
          v-model="baseInfo.card_id"
          clearable
          maxlength="18"
          name="证件号码"
          label="证件号码"
          placeholder="请输入证件号码"
        />
        <van-field name="radio" required label="性别">
          <template #input>
            <van-radio-group v-model="baseInfo.gender" checked-color='#edad57' direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
        required
          readonly
          clickable
          name="datetimePicker"
          :value="baseInfo.birth"
          label="年月日"
          placeholder="请选择出生日期"
          :rules="[{ required: true }]"
          @click="birthShowPicker = true"
        />
        <van-popup v-model="birthShowPicker" position="bottom">
          <van-datetime-picker
            :min-date="minDate"
            type="date"
            @confirm="birthConfirm"
            @cancel="birthShowPicker = false"
          />
        </van-popup>
        <van-field
        required
          readonly
          clickable
          name="picker"
          :value="baseInfo.marry"
          label="婚姻状况"
          placeholder="请选择选择婚姻状况"
          @click="marryTypePicker = true"
          :rules="[{ required: true }]"
        />
        <van-popup v-model="marryTypePicker" required position="bottom">
          <van-picker
            show-toolbar
            :columns="marryList"
            @confirm="marryTypeConfirm"
            @cancel="marryTypePicker = false"
          />
        </van-popup>
        <van-field
        required
          readonly
          clickable
          name="area"
          :value="baseInfo.now_address"
          label="现居住地址"
          placeholder="请选择省市区"
          @click="isShowArea = true"
          :rules="[{ required: true}]"
        />
        <van-popup v-model="isShowArea" position="bottom">
          <van-area
            :area-list="areaList"
            :value='setAddress'
            @confirm="nowAddressConfirm"
            @cancel="isShowArea = false"
          />
        </van-popup>
        <van-field
        required
          v-model="baseInfo.address_details"
          clearable
          name="详细地址"
          label="详细地址"
          placeholder="街道门牌、楼层房间号等信息"
          :rules="[{ required: true}]"
        />
        <van-field
          v-model="baseInfo.height"
          clearable
          label="身高(cm)"
          placeholder="请输入身高"
        />
        <van-field
          v-model="baseInfo.weight"
          clearable
          label="体重(kg)"
          placeholder="请输入体重"
        />
        <van-field
          v-model="baseInfo.interest"
          clearable
          rows="1"
          autosize
          label="兴趣特长"
          type="textarea"
          placeholder="请输入兴趣特长"
        />
        <div style="margin: 16px;"></div>
        <van-field
          clearable
          v-model="baseInfo.emergency_contact"
          name="紧急联系人"
          label="紧急联系人"
          placeholder="请填写紧急联系人姓名"
        />
        <van-field
          clearable
          v-model="baseInfo.emergency_type"
          name="关系"
          label="关系"
          placeholder="请填写关系，如：父子"
        />
        <van-field
          v-model.trim="baseInfo.emergency_phone"
          type='tel'
          clearable
          maxlength="11"
          name="紧急联系方式"
          label="紧急联系方式"
          placeholder="请填写手机号码"
        />
        <div style="margin: 60px 16px 44px 16px;">
          <van-button style='font-size:16px; border-radius:5px;'  block type="info" color='#E39E54' @click="submitBaseInfo" >下一步</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import FillStep from "../userRegistration/comp/fillStep";
import { mapState, mapMutations } from "vuex";
import areaList from "../../assets/js/area"
import moment from "moment"
import _ from "lodash"
import { getNumArray, validatorIDCard, urlAddParams } from '@/utils/tool';
const SEX = {
  male: { v: '1', t: '男'},
  female: { v: '2', t: '女'},
}
  export default {
    name: 'baseInfo',
    data() {
      return {
        baseInfo :{
          apply_job_name: '',
          can_work_time: '',
          expected_salary: '',
          name: '',
          phone: '',
          e_mail: '',
          card_type:'中国居民身份证',
          card_id:'',
          gender: '1',
          birth: '',
          marry:'',
          now_address:'',
          address_details:'',
          interest:'',
          emergency_contact:'',
          emergency_type:'',
          emergency_phone:'',
          height: '',
          weight: '',
        },
        // setAddress: [{code: "440000", name: "广东省"}, {code: "440100", name: "广州市"}, {code: "440106", name: "天河区"}],
        setAddress: "440106",
        minDate: new Date(1970, 0, 1),
        workTimePicker: false,
        workTimeSelect:["随时到岗","3天到岗","7天到岗",'2周到岗',"月内到岗"],
        emailErrorText:'',
        cardTypePicker: false,
        cardType:["中国居民身份证","非内地居民护照"],
        birthShowPicker: false,
        isShowArea: false,
        areaList,
        marryList:['已婚已育','离异','已婚未育','未婚'],
        marryTypePicker: false,
        salaryTypePicker: false,
        salary:[
          {
            values: [],
            defaultIndex: 0,
          },
          {
            values: [],
            defaultIndex: 0,
          },
        ]
      }
    },
    beforeRouteLeave(to, from, next){
      this.$refs.form.validate().then( 
          res => {
            localStorage.setItem('baseinfo', JSON.stringify(this.baseInfo))
        next()
          }
        ).catch( err => {
          this.$toast({
              message: "请输入必填信息",
              icon:'warning-o',
              duration: 2500
            })
          return
        })
    },
    computed:{
      ...mapState([ "baseinfo" ]),
    },
    components:{
      FillStep
    },
    methods:{
      ...mapMutations([ "SET_BASE_INFO" ]),
      onChange(picker, val){
        let index = this.salary[0].values.indexOf(val[0]);
        let tmpData = _.cloneDeep(this.salary[0].values);
        console.log(index)
        this.salary[1].values =  _.cloneDeep(this.salary[0].values).splice(index+1, 3)
        if( this.salary[1].values.length == 0){
          this.salary[1].values.push(val[0])
        }
      },
      salaryTypeConfirm(val){
        if(val[0] == val[1]){
          this.baseInfo.expected_salary = val[0]
        }else{
          this.baseInfo.expected_salary = val[0]+" — "+val[1]
        }
        this.salaryTypePicker = false;
      },
      fillCardId(val) {
        let {code} = validatorIDCard(val);
        let ispass = code === 1;
        if (ispass) {
          let year = val.substr(6, 4),
            month = val.substr(10, 2),
            day = val.substr(12, 2),
            sex = val.substring(16, 17);
          this.baseInfo.birth = year + '-' + month + '-' + day;
          this.baseInfo.gender = sex % 2 === 0 ? SEX.female.v : SEX.male.v;
        }
        return ispass
      },
      workTimeConfirm(val) {
        this.baseInfo.can_work_time = val;
        this.workTimePicker = false;
      },
      cardTypeConfirm(val){
        this.baseInfo.card_type = val;
        this.cardTypePicker = false;
      },
      marryTypeConfirm(val){
        this.baseInfo.marry = val;
        this.marryTypePicker = false;
      },
      birthConfirm(val){
        this.baseInfo.birth = moment(val).format("YYYY-MM-DD");
        this.birthShowPicker = false;
      },
      nowAddressConfirm(val) {
        this.baseInfo.now_address = val.filter((item) => !!item).map((item) => item.name).join('/');
        this.isShowArea = false;
      },
      salaryChange(val){
        this.$toast('￥：' + val);
      },
      submitBaseInfo() {
        this.$refs.form.validate().then( 
          res => {
            this.SET_BASE_INFO(this.baseInfo)
            const path = urlAddParams('/education', this.$route.query);
            this.$router.replace(path);
          }
        ).catch( err => {
          this.$toast({
              message: "请输入必填信息",
              icon:'warning-o',
              duration: 2500
            })
          return
        })
      }
    },
    mounted(){
      let tmpNum = []
      _.map(getNumArray(1, 100), item => {
        tmpNum.push(item+"K")
      })
      this.salary[0].values = _.cloneDeep(tmpNum)
      this.salary[1].values =  _.cloneDeep(tmpNum).slice(1,4)
      
      window.scrollTo(0,0)
      let dataInfo = JSON.parse(localStorage.getItem('loginInfo'));
      this.baseInfo.name = dataInfo.name;
      this.baseInfo.e_mail = dataInfo.e_mail;
      this.baseInfo.phone = dataInfo.phone;
      this.baseInfo.apply_job_name = dataInfo.position_sub_name;
      this.baseInfo.ability_id = dataInfo.ability_id;
      this.$forceUpdate(); //强制刷新
      if( JSON.parse(localStorage.getItem('baseinfo')) != null){
        this.baseInfo = JSON.parse(localStorage.getItem('baseinfo'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
@import "../../assets/css/page.css";
.base-wrap{
  height: 100%;
}
</style>